import { PERMISSION_DATA } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { IPermissionDataRepository } from "../domain/repositories/IPermissionDataRepository";
import { PermissionDataDetailResponseModel } from "./models/PermissionDataDetailResponseModel";
import { PermissionDataRequestModel } from "./models/PermissionDataRequestModel";
import { PermissionDataResponseModel } from "./models/PermissionDataResponseModel";

@injectable()
export class PermissionDataImpl implements IPermissionDataRepository {
  async getList(
    params: PermissionDataRequestModel,
  ): Promise<ListBaseApiResponseModel<PermissionDataResponseModel>> {
    return await client?.get(PERMISSION_DATA.LIST, params);
  }

  async getDetail(
    params: PermissionDataRequestModel,
  ): Promise<BaseApiResponseModel<PermissionDataDetailResponseModel>> {
    return await client?.get(PERMISSION_DATA.DETAIL, params);
  }
}
